export default __webpack_public_path__ + "img/ec547b1aa11ae08b7b8bf9f0ded4e8c1.svg";